<template>
  <div style="background-color: #F6F6F6;padding-top: 64px;">
    <!-- 行业 -->
    <div class="shade-unify" v-if="isindustry==true"></div>
    <div class="hotss-unify" v-if="isindustry==true"  style="z-index: 999;position: fixed;left: 0;right: 0;height: 500px">
      <div class="hots-titles-unify" style="overflow: hidden;padding-top: 25px;">
        <div style="float: left;">请选择职位类别</div>
        <img style="float: right;width: 24px;height: 24px;margin-right: 16px;" src="../../assets/close.png" @click="close()" alt="">
      </div>
      <div class="hots-contents-unify">
        <div class="hots-left-unify">
          <div v-for="(item,index) in tradeList" class="hots-left-label-unify" :key="index" @mouseenter="changePosition(index)">
            <div :class="index==tradeListIndex ? 'active' : ''">{{item.name}}</div>
          </div>
        </div>
        <div class="hots-right-unify" :key="freshKey">
          <div class="hots-right-box-unify">
<!--            <div class="hots-right-h1">{{item.name}}</div>-->
            <div class="hots-right-cont-unify">
              <div style="padding: 5px;border-radius: 4px;background-color: #F1F2F6;" v-for="(item,index) in tradeList[tradeListIndex].list" :key="index" @click="chooseTrade(item.id,item.name)">{{item.name}}</div>
<!--              v-for="(item,index) in tradeList[tradeListIndex].list[index].list" :key="index"-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 行业 -->
    <div style="background-color: rgb(246, 246, 246);width: 1200px;margin: 0 auto;margin-top: 27px;">
      <div class="enterpriseDetails-bottom">
        <!--新2023-4-26-->
        <div class="resume-box-releaseJobVue">
          <!--2023-4-24-->
          <div class="resume-left-releaseJobVue">
            <div class="resume-modular-filling-releaseJobVue">
              <!--职位信息-->
              <div class="resume-modular-fillBox-releaseJobVue">
                <img src="../../assets/index-line.png" style="margin-bottom: 20px;" alt="">
                <div class="resume-modular-title-name-releaseJobVue">
                  <div style="display: inline-block">职位信息</div>
                </div>
                <!-- 用工类型、职位名称-->
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-releaseJobVue">
                      <div class="fillResumeDetails-name-releaseJobVue">用工类型</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue">
                      <el-dropdown @command="handleTypes" style="height: 36px;line-height: 36px;width: 99%;border: 1px solid #DFDFDF">
                        <span class="el-dropdown-link" style="margin-left: 1rem;display: inline-block;position: relative;width: 100%;height: 100%;">
                          {{jobInfo.typeName}}<i class="el-icon-arrow-down el-icon--right" style="float: right;position: absolute;right: 20px;line-height: 36px;margin-top: 0;"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item style="width:320px;" v-for="(item, index) in typeList" :key="index" :command="beforeHandleCommand(item.name, item.id)">{{item.name}}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-releaseJobVue">
                      <div class="fillResumeDetails-name-releaseJobVue">职位名称</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue">
                      <input v-model="jobInfo.name" class="resume-fill-detils-releaseJobVue" type="text" >
                    </div>
                  </div>
                </div>
                <!-- 用工类型、职位名称-->
                <!-- 职位类型、行业名称-->
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-releaseJobVue">
                      <div class="fillResumeDetails-name-releaseJobVue">职位类型</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue">
                      <el-dropdown @command="handlejobType" style="height: 36px;line-height: 36px;width: 99%;border: 1px solid #DFDFDF">
                        <span class="el-dropdown-link" style="margin-left: 1rem;display: inline-block;position: relative;width: 100%;height: 100%;">
                          {{jobInfo.jobTypeName}}<i class="el-icon-arrow-down el-icon--right" style="float: right;position: absolute;right: 20px;line-height: 36px;margin-top: 0;"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item style="width:320px;" v-for="(item, index) in jobTypeList" :key="index" :command="beforeHandleCommand(item.name, item.value)">{{item.name}}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-releaseJobVue">
                      <div class="fillResumeDetails-name-releaseJobVue">行业名称</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue" @click="selectIndustry()">
                      <div style="height: 36px;line-height: 36px;width: 95%;border: 1px solid #DFDFDF;padding-left: 1rem;color:#6a6f77;font-size: 14px;">{{jobInfo.tradeName}}</div>
                    </div>
                  </div>
                </div>
                <!-- 职位类型、行业名称-->
                <!--联系人、联系电话-->
                <!-- 职位类型、行业名称-->
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-releaseJobVue">
                      <div class="fillResumeDetails-name-releaseJobVue">联系人</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue">
                      <input v-model="jobInfo.linkMan" class="resume-fill-detils-releaseJobVue" type="text" maxlength="4" >
                    </div>
                  </div>
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-releaseJobVue">
                      <div class="fillResumeDetails-name-releaseJobVue">联系方式</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue">
                      <input v-model="jobInfo.linkPhone" class="resume-fill-detils-releaseJobVue" type="number" style="width: 80%;float: left" maxlength="12">
                      <el-radio  v-if="jobInfo.isShowLinkPhone==1"  v-model="jobInfo.isShowLinkPhone" :label="1"   @click.native.prevent="change(1)" class="linkmanRadio" style="border-color:#1fb72a;color: #1fb72a" >公开</el-radio>
                      <el-radio  v-if="jobInfo.isShowLinkPhone==2" v-model="jobInfo.isShowLinkPhone" :label="2"   @click.native.prevent="change(2)" class="linkmanRadio linkmanRadios" style="color: #dfdfdf">公开</el-radio>
                    </div>

                  </div>
                </div>
                <!-- 职位描述-->
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-releaseJobVue">
                      <div class="fillResumeDetails-name-releaseJobVue">职位描述</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fill-introduce-releaseJobVue">
                        <textarea type="text" class="resume-fill-textarea-releaseJobVue" name=""  cols="30" rows="5" style="" v-model="jobInfo.content1"
                                  placeholder="请输入工作描述："></textarea>
                    </div>
                  </div>
                </div>
                <!-- 职位描述-->
              </div>
              <!--职位信息-->
              <!--职位要求-->
              <div class="resume-modular-fillBox-releaseJobVue">
                <img src="../../assets/index-line.png" style="margin-bottom: 20px;" alt="">
                <div class="resume-modular-title-name-releaseJobVue">职位要求</div>
                <!-- 学历、工作经验-->
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue" style="padding-bottom: 6px;">
                    <div class="fillBusinessDetails-name-releaseJobVue">
                      <div class="fillResumeDetails-name-releaseJobVue">学历</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue">
                      <el-dropdown @command="handleEdu" style="height: 36px;line-height: 36px;width: 99%;border: 1px solid #DFDFDF;">
                        <span class="el-dropdown-link" style="padding-left: 1rem;display: inline-block;position: relative;width: 100%;height: 100%;">
                          {{jobInfo.eduName}}
                          <i class="el-icon-arrow-down el-icon--right" style="float: right;position: absolute;right: 30px;line-height: 36px;margin-top: 0"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" v-if="eduList.length!==0">
                          <el-dropdown-item v-for="(item,index) in eduList" :key="index" style="width: 320px;" :command="beforeHandleCommand(item.name, item.value)">{{ item.name }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                  <div class="resume-fillDetails-releaseJobVue" style="padding-bottom: 6px;">
                    <div class="fillBusinessDetails-name-releaseJobVue">
                      <div class="fillResumeDetails-name-releaseJobVue">工作经验</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue" style="border: none;">
                      <el-dropdown @command="handleWork" style="height: 36px;line-height: 36px;width: 99%;border: 1px solid #DFDFDF;">
                        <span class="el-dropdown-link" style="padding-left: 1rem;display: inline-block;position: relative;width: 100%;height: 100%;">
                          {{jobInfo.workName}}
                          <i class="el-icon-arrow-down el-icon--right" style="float: right;position: absolute;right: 30px;line-height: 36px;margin-top: 0"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" v-if="workList.length!==0">
                          <el-dropdown-item v-for="(item,index) in workList" :key="index" style="width: 320px;" :command="beforeHandleCommand(item.name, item.value)">{{ item.name }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                </div>
                <!-- 学历、工作经验-->
                <!-- 工作地址、职位薪水-->
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue">
                    <div class="fillBusinessDetails-name-releaseJobVue">
                      <div class="fillResumeDetails-name-releaseJobVue">工作地址</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue" style="display: flex">
                      <el-dropdown style="flex: 1;height: 36px;line-height: 36px;margin-right: 14px;border: 1px solid #DFDFDF;position: relative;" @command="handleProvince">
                        <span class="el-dropdown-link" style="display: inline-block; width: 90%; height: 100%;padding-left: 10%;">
                          {{jobInfo.provinceName}}<i class="el-icon-arrow-down el-icon&#45;&#45;right" style="width:100%;line-height: 36px;position: absolute;right: 1em;text-align: right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="project-dropdown">
                          <el-dropdown-item v-for="(item,index) in areaList" :key="index" style="width: 68px;"
                                            :command="beforeHandleCommand(item.name, item.id)">{{ item.name }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-dropdown style="flex: 1;height: 36px;line-height: 36px;margin-right: 14px;border: 1px solid #DFDFDF;position: relative;" @command="handleCity">
                        <span class="el-dropdown-link" style="display: inline-block; width: 90%; height: 100%;padding-left: 10%;">
                          {{jobInfo.cityName}}<i class="el-icon-arrow-down el-icon&#45;&#45;right" style="width:100%;line-height: 36px;position: absolute;right: 1em;text-align: right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="project-dropdown">
                          <el-dropdown-item v-for="(item,index) in cityList" style="width: 68px;" :key="index" :command="beforeHandleCommand(item.name, item.id)">{{ item.name }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-dropdown style="flex: 1;height: 36px;line-height: 36px;margin-right: 14px;border: 1px solid #DFDFDF;position: relative;" @command="handleArea">
                        <span class="el-dropdown-link" style="display: inline-block; width: 90%; height: 100%;padding-left: 10%;">
                          {{jobInfo.areaName}}<i class="el-icon-arrow-down el-icon&#45;&#45;right" style="width:100%;line-height: 36px;position: absolute;right: 1em;text-align: right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="project-dropdown">
                          <el-dropdown-item v-for="(item,index) in districtList" style="width: 68px;" :key="index" :command="beforeHandleCommand(item.name, item.id)">{{ item.name }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>

                  <div class="resume-fillDetails-releaseJobVue" style="padding-bottom: 6px;">
                    <div class="fillBusinessDetails-name-releaseJobVue">
                      <div class="fillResumeDetails-name-releaseJobVue">职位薪水</div>
                      <div class="asterisk">*</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue">
                      <el-dropdown @command="handleSalary" style="height: 36px;line-height: 36px;width: 99%;border: 1px solid #DFDFDF;">
                        <span class="el-dropdown-link" style="padding-left: 1rem;display: inline-block;position: relative;width: 100%;height: 100%;">
                          {{jobInfo.salaryName}}
                          <i class="el-icon-arrow-down el-icon--right" style="float: right;position: absolute;right: 30px;line-height: 36px;margin-top: 0"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" v-if="salaryList.length!==0">
                          <el-dropdown-item v-for="(item,index) in salaryList" :key="index" style="width: 320px;" :command="beforeHandleCommand(item.name, item.id)">{{ item.name }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                </div>
                <!-- 工作地址、职位薪水-->
                <!-- 详细地址-->
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue" style="padding-bottom: 6px;">
                    <div class="fillBusinessDetails-name-releaseJobVue">
                      <div class="fillResumeDetails-name-releaseJobVue">详细地址</div>
                    </div>
                    <div class="resume-fillDetails-content-releaseJobVue" style="border: none;">
                      <input v-model="jobInfo.address" class="resume-fill-detils-releaseJobVue" type="text">
                    </div>
                  </div>
                </div>
              </div>
              <!--其他补充-->
              <div class="resume-modular-fillBox-releaseJobVue">
                <img src="../../assets/index-line.png" style="margin-bottom: 20px;" alt="">
                <div class="resume-modular-title-name-releaseJobVue">其他补充</div>
                <!-- 岗位要求、福利待遇-->
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue" style="padding-bottom: 6px;">
                    <div class="fillBusinessDetails-name-releaseJobVue">
                      <div class="fillResumeDetails-name-releaseJobVue">岗位要求</div>
                      <!--                      <div class="asterisk">*</div>-->
                    </div>
                    <div class="resume-fill-introduce-releaseJobVue">
                        <textarea type="text" class="resume-fill-textarea-releaseJobVue"  cols="30" rows="4" style="" v-model="jobInfo.content2"
                                  placeholder="请输入岗位要求："></textarea>
                    </div>
                  </div>
                </div>
                <div class="resume-modular-fill-releaseJobVue">
                  <div class="resume-fillDetails-releaseJobVue" style="padding-bottom: 6px;">
                    <div class="fillBusinessDetails-name-releaseJobVue">
                      <div class="fillResumeDetails-name-releaseJobVue">福利待遇</div>
                    </div>
                    <div class="resume-fill-introduce-releaseJobVue">
                        <textarea type="text" class="resume-fill-textarea-releaseJobVue" name="" id="" cols="30" rows="4" style="" v-model="jobInfo.content3"
                                  placeholder="请输入福利待遇："></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 保存发布岗位 -->
              <div class="resumeBtns-releaseJobVue">
                <button class="resumeSub-releaseJobVue resumeCheckBtnItem-releaseJobVue" v-if="jobInfo.id==null" @click="submitJob()">发布</button>
                <button class="resumeSub-releaseJobVue resumeCheckBtnItem-releaseJobVue" v-else @click="submitJob()">修改</button>
                <button class="resumeCancel-releaseJobVue resumeCheckBtnItem-releaseJobVue" @click="back()">取消</button>
              </div>
              <!-- 保存发布岗位 -->
            </div>
          </div>
          <!--右-->
          <div class="personalCore-right-releaseJobVue">
            <div class="personalCore-right-info-releaseJobVue">
              <img :src="userInfo.userPhoto"/>
              <div class="releaseJobVue-right-info-div-box">
                <div style="font-weight: bold;width: 144px;">{{userInfo.companyName}}</div>
                <div class="personalCores-right-info-div-vip" v-if="userInfo.isCompanyVip==true">企业会员</div>
              </div>
            </div>
            <div class="personalCore-right-box">
              <div class="personalCore-right-boxs" style="margin-left: 32px;" @click="go()">
                <img src="../../assets/Enterprise-icon1.png" />
                <div>职位列表</div>
              </div>
              <div class="personalCore-right-boxs" style="margin-left: 24px;" @click="curriculumVitae()">
                <img src="../../assets/Enterprise-icon2.png" />
                <div>简历管理</div>
              </div>
              <div class="personalCore-right-boxs" style="margin-left: 32px;" @click="goss()">
                <img src="../../assets/Enterprise-icon4.png" />
                <div>企业信息</div>
              </div>
              <div class="personalCore-right-boxs" v-if="jobInfo.id!=null" style="margin-left: 24px;" @click="postRelease()">
                <img src="../../assets/Enterprise-icon3.png" />
                <div>发布职位</div>
              </div>
              <div class="personalCore-right-boxs" v-if="jobInfo.id==null"  style="margin-left: 24px;" >
                <img src="../../assets/Enterprise-icon3.png" />
                <div>发布职位</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../../util/request'

export default {
  data () {
    return {
      userInfo: {},
      jobInfo: {},
      jobTypeList: [],
      areaList: [],
      cityList: [],
      districtList: [],
      tagList: [],
      tradeList: [],
      typeList: [],
      eduList: [],
      workList: [],
      salaryList: [],
      // type: '',
      // name: '',
      // jobType: '',
      // jobTypeId: '',
      // areaId: '',
      // cityId: '',
      // districtId: '',
      // workId: '',
      // salaryId: '',
      // eduId: '',
      // typeId: '',
      // tradeId: '',
      // work: '',
      // edu: '',
      // salary: '',
      // area: '',
      // city: '',
      // district: '',
      // address: '',
      // content1: '',
      // content2: '',
      // content3: '',
      tradeListIndex: 0,
      trade: '',
      freshKey: 1,
      isindustry: false,
      id: '',
      linkMan: '', // 联系人
      linkPhone: '' // 联系电话
      // isShowLinkPhone: 2
    }
  },
  beforeCreate () {
    this.$nextTick(() => {
      this.getData()
    })
  },
  mounted () {
    this.id = this.$route.query.id
  },
  methods: {
    getData () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user/getJob`,
        data: JSON.stringify({
          id: that.id
        })
      }).then(
        (res) => {
          if (res.data.code === 200) {
            that.typeList = res.data.data.typeList
            that.jobTypeList = res.data.data.jobTypeList
            that.workList = res.data.data.workList
            that.eduList = res.data.data.eduList
            that.salaryList = res.data.data.salaryList
            that.areaList = res.data.data.areaList
            that.jobInfo = res.data.data.jobInfo
            // if (that.jobInfo.name !== null) {
            //   that.name = that.jobInfo.name
            // }
            // if (that.jobInfo.content1 !== null) {
            //   that.content1 = that.jobInfo.content1
            // }
            // if (that.jobInfo.content2 !== null) {
            //   that.content2 = that.jobInfo.content2
            // }
            // if (that.jobInfo.content3 !== null) {
            //   that.content3 = that.jobInfo.content3
            // }
            // if (that.jobInfo.address !== null) {
            //   that.address = that.jobInfo.address
            // }

            // var obj = {imgUrl: e.currentTarget.result}
            // this.swiperList.push(obj)
            if (that.jobInfo.isShowLinkPhone === null) {
              that.jobInfo.isShowLinkPhone = 2
            }
            if (that.jobInfo.jobType !== null) {
              that.jobTypeList.forEach(function (item, index) {
                if (item.value === that.jobInfo.jobType) {
                  // that.jobType = item.name
                  // that.jobTypeId = item.value
                  that.jobInfo.jobTypeName = item.name
                }
              })
            }
            if (that.jobInfo.type !== null) {
              that.typeList.forEach(function (item, index) {
                if (item.id === that.jobInfo.type) {
                  // that.type = item.name
                  // that.typeId = item.id
                  that.jobInfo.typeName = item.name
                }
              })
            }
            if (that.jobInfo.edu !== null) {
              that.eduList.forEach(function (item, index) {
                if (item.value === that.jobInfo.edu) {
                  // that.edu = item.name
                  // that.eduId = item.value
                  that.jobInfo.eduName = item.name
                }
              })
            }
            if (that.jobInfo.work !== null) {
              that.workList.forEach(function (item, index) {
                if (item.value === that.jobInfo.work) {
                  that.jobInfo.workName = item.name
                }
              })
            }
            if (that.jobInfo.salary !== null) {
              that.salaryList.forEach(function (item, index) {
                if (item.id === that.jobInfo.salaryId) {
                  that.jobInfo.salaryName = item.name
                }
              })
            }
            if (that.jobInfo.province !== null) {
              var province = that.jobInfo.province * 1
              that.areaList.forEach(function (item, index) {
                if (item.id === province) {
                  that.jobInfo.provinceName = item.name
                  // that.areaId = item.id
                  that.getCitys()
                }
              })
            } else {
              that.jobInfo.province = res.data.data.areaList[0].id
              that.jobInfo.provinceName = res.data.data.areaList[0].name
              that.getCitys()
            }
          }
          this.$forceUpdate()
        },
        (err) => {
          that.$message.error(err)
        }
      )
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.userInfo = res.data.data.userInfo
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    // 获取市
    getCity () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/area/getAreaList`,
        data: JSON.stringify({
          id: that.jobInfo.province
        })
      }).then(
        (res) => {
          that.cityList = res.data.data.areaList
          that.jobInfo.city = res.data.data.areaList[0].id
          that.jobInfo.cityName = res.data.data.areaList[0].name
          that.getDistrict()
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },

    // 获取区
    getDistrict () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/area/getAreaList`,
        data: JSON.stringify({
          id: that.jobInfo.city
        })
      }).then(
        (res) => {
          that.districtList = res.data.data.areaList
          that.jobInfo.area = res.data.data.areaList[0].id
          that.jobInfo.areaName = res.data.data.areaList[0].name
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    // 获取市
    getCitys () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/area/getAreaList`,
        data: JSON.stringify({
          // id: that.areaId
          id: that.jobInfo.province
        })
      }).then(
        (res) => {
          that.cityList = res.data.data.areaList
          if (that.jobInfo.city !== null) {
            var city = that.jobInfo.city * 1
            that.cityList.forEach(function (item, index) {
              if (item.id === city) {
                that.jobInfo.cityName = item.name
                // that.jobInfo.city = item.id
                that.getDistricts()
              }
            })
          } else {
            that.jobInfo.city = res.data.data.areaList[0].id
            that.jobInfo.cityName = res.data.data.areaList[0].name
            that.getDistricts()
          }
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    // 获取区
    getDistricts () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/area/getAreaList`,
        data: JSON.stringify({
          id: that.jobInfo.city
        })
      }).then(
        (res) => {
          that.districtList = res.data.data.areaList
          if (that.jobInfo.area !== null) {
            var area = that.jobInfo.area * 1
            that.districtList.forEach(function (item, index) {
              if (item.id === area) {
                that.jobInfo.areaName = item.name
                // that.districtId = item.id
              }
            })
          } else {
            that.jobInfo.area = res.data.data.areaList[0].id
            that.jobInfo.areaName = res.data.data.areaList[0].name
          }
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    change (e) {
      var that = this
      if (e === 2) {
        // that.isShowLinkPhone = 1
        that.jobInfo.isShowLinkPhone = 1
      } else {
        // that.isShowLinkPhone = 2
        that.jobInfo.isShowLinkPhone = 2
      }
    },
    beforeHandleCommand (name, id) {
      return {
        id: id,
        name: name
      }
    },
    // 工作类别
    handleTypes (command) {
      // console.log(command.name)
      this.jobInfo.typeName = command.name
      this.jobInfo.type = command.id
      this.$forceUpdate()
    },
    // 职位类型
    handlejobType (command) {
      this.jobInfo.jobTypeName = command.name
      this.jobInfo.jobType = command.id
      this.$forceUpdate()
      // this.jobInfo = _.clone(this.jobInfo)
      // this.$set(this.jobInfo, 'jobTypeName', command.name)
      // this.jobInfo = Object.assign({}, this.jobInfo, {jobTypeName: command.name, jobType: command.id})
    },
    // 行业
    selectIndustry () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user/tradeList`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.tradeList = res.data.data.tradeList
          that.isindustry = true
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    chooseTrade (id, name) {
      this.jobInfo.tradeName = name
      this.jobInfo.trade = id
      this.isindustry = false
      this.$forceUpdate()
    },
    changePosition (e) {
      this.tradeListIndex = e
      this.freshKey = new Date().getTime()
    },
    close () {
      this.isindustry = false
    },
    // 职位类型
    // changeType (id, index) {
    //   this.typeIndex = index
    //   this.typeId = id
    // },
    // 工作经验
    handleWork (command) {
      this.jobInfo.workName = command.name
      this.jobInfo.work = command.id
      this.$forceUpdate()
    },
    // 学历
    handleEdu (command) {
      this.jobInfo.eduName = command.name
      this.jobInfo.edu = command.id
      this.$forceUpdate()
    },
    // 薪资范围
    handleSalary (command) {
      this.jobInfo.salaryName = command.name
      this.jobInfo.salaryId = command.id
      this.$forceUpdate()
    },
    select (index, check) {
      var that = this
      if (check === false) {
        that.tagList[index].check = true
        this.$forceUpdate()
      } else {
        that.tagList[index].check = false
        this.$forceUpdate()
      }
    },
    // 省
    handleProvince (command) {
      this.jobInfo.province = command.id
      this.jobInfo.provinceName = command.name
      this.jobInfo.city = ''
      this.jobInfo.cityName = ''
      this.$forceUpdate()
      this.getCity()
    },
    // 市
    handleCity (command) {
      this.jobInfo.city = command.id
      this.jobInfo.cityName = command.name
      this.$forceUpdate()
      this.getDistrict()
    },
    // 区
    handleArea (command) {
      this.jobInfo.areaName = command.name
      this.jobInfo.areaId = command.id
      this.$forceUpdate()
    },
    submitJob () {
      var that = this
      if (that.jobInfo.name === null) {
        that.$message.error('请输入职位名称')
        return false
      }
      if (that.jobInfo.jobType === null) {
        that.$message.error('请选择职位类别')
        return false
      }
      if (that.jobInfo.trade === null) {
        that.$message.error('请选择行业')
        return false
      }
      if (that.jobInfo.type === null) {
        that.$message.error('请选择用工类型')
        return false
      }
      if (that.jobInfo.linkMan === null) {
        that.$message.error('请输入联系人')
        return false
      }
      if (that.jobInfo.linkPhone === null) {
        that.$message.error('请输入联系人的联系电话')
        return false
      }
      if (that.jobInfo.work === null) {
        that.$message.error('请选择工作经验')
        return false
      }
      if (that.jobInfo.edu === null) {
        that.$message.error('请选择学历')
        return false
      }
      if (that.jobInfo.salaryId === null) {
        that.$message.error('请选择职位薪水')
        return false
      }
      if (that.jobInfo.content1 === null) {
        that.$message.error('请输入职位描述')
        return false
      }
      // console.log(that.jobInfo.content2)
      if (that.jobInfo.content2 === null) {
        that.$message.error('请输入岗位要求')
        return false
      }
      if (that.jobInfo.content3 === null) {
        that.$message.error('请输入福利待遇')
        return false
      }
      if (that.jobInfo.province === null) {
        that.$message.error('请选择所属省')
        return false
      }
      if (that.jobInfo.city === null) {
        that.$message.error('请选择所属市')
        return false
      }
      if (that.jobInfo.area === null) {
        that.$message.error('请选择所属区')
        return false
      }

      if (that.jobInfo.isShowLinkPhone === '') {
        that.jobInfo.isShowLinkPhone = 2
      }
      // if (that.jobInfo.address === '') {
      //   that.$message.error('请输入详细地址')
      //   return false
      // }
      // console.log(that.jobInfo.id)
      if (that.jobInfo.id != null) {
        request({
          method: 'post',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            token: '',
            Bearer: localStorage.getItem('token')
          },
          url: `/web/user/addJob`,
          data: JSON.stringify({
            name: that.jobInfo.name,
            jobType: that.jobInfo.jobType,
            trade: that.jobInfo.trade,
            type: that.jobInfo.type,
            work: that.jobInfo.work,
            edu: that.jobInfo.edu,
            salary: that.jobInfo.salaryId,
            province: that.jobInfo.province,
            city: that.jobInfo.city,
            area: that.jobInfo.area,
            address: that.jobInfo.address,
            content1: that.jobInfo.content1,
            content2: that.jobInfo.content2,
            content3: that.jobInfo.content3,
            id: that.jobInfo.id,
            linkMan: that.jobInfo.linkMan,
            linkPhone: that.jobInfo.linkPhone,
            isShowLinkPhone: that.jobInfo.isShowLinkPhone
          })
        }).then(
          (res) => {
            if (res.data.code === 200) {
              this.$notify.success({
                title: '',
                message: '修改成功'
              })
              this.$router.push({ path: '/jobLists' })
            }
          },
          (err) => {
            this.$message.error(err)
          }
        )
      } else {
        request({
          method: 'post',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            token: '',
            Bearer: localStorage.getItem('token')
          },
          url: `/web/user/addJob`,
          data: JSON.stringify({
            name: that.jobInfo.name,
            jobType: that.jobInfo.jobType,
            trade: that.jobInfo.trade,
            type: that.jobInfo.type,
            work: that.jobInfo.work,
            edu: that.jobInfo.edu,
            salary: that.jobInfo.salaryId,
            province: that.jobInfo.province,
            city: that.jobInfo.city,
            area: that.jobInfo.area,
            address: that.jobInfo.address,
            content1: that.jobInfo.content1,
            content2: that.jobInfo.content2,
            content3: that.jobInfo.content3,
            linkMan: that.jobInfo.linkMan,
            linkPhone: that.jobInfo.linkPhone,
            isShowLinkPhone: that.jobInfo.isShowLinkPhone
          })
        }).then(
          (res) => {
            if (res.data.code === 200) {
              this.$notify.success({
                title: '',
                message: '发布成功'
              })
              this.$router.push({ path: '/jobLists' })
            }
          },
          (err) => {
            this.$message.error(err)
          }
        )
      }
    },
    navigationGo (e) {
      this.jobIndex = e
      if (this.jobIndex === 0) {
        this.$router.push({ path: '/' })
      }
    },
    go () {
      this.$router.push({ path: '/jobLists' })
    },
    postRelease () {
      this.$router.push({ path: '/releaseJob' })
    },
    goss () {
      this.$router.push({ path: '/enterpriseInformation' })
    },
    curriculumVitae () {
      this.$router.push({ path: '/curriculumVitae' })
    },
    back () {
      this.$router.go(-1)
    }
  }
}

</script>

<style>
.enterpriseDetails-bottom{
  overflow: hidden;
  margin-top: 41px;
}
.company-information-lt {
	float: left;
	margin-right: 28px;
}
.company-information {
	width: 649px;
	margin-bottom: 22px;
	padding:26px 44px 40px 33px;
	background-color: #ffffff;
	overflow: hidden;
}
.company-information-details {
	float: left;
	width: 100%;
}
.company-information-name {
	font-size: 22px;
	letter-spacing: 2px;
	color: #000000;
	font-weight: 550;
	margin-bottom: 26px;
}
.businessDetails {
	overflow: hidden;
	margin-top: 36px;
}
.businessDetails-name {
	float: left;
	overflow: hidden;
	margin-left: 27px;
	margin-right: 18px;
	width: 80px;
}

.businessDetails-name div {
	float: left;
	font-size: 16px;
}
.businessDetails-content {
	float: left;
	overflow: hidden;
	width: 500px;
	position: relative;
}
/* 薪酬范围 */
.businessDetails-input {
	outline: 0;
	box-sizing: border-box;
	/* text-align:center; */
	font-size: 16px;
	height: 28px;
	border-radius: 4px;
	border: none;
	color: #6a6f77;
	display: block;
	outline: 0;
	padding: 0 1em;
	text-decoration: none;
	width: 100%;
	background-color: #FAFAFA;
}
.businessDetails-textarea {
	outline: 0;
	box-sizing: border-box;
	/* text-align:center; */
	font-size: 16px;
	line-height: 20px;
	/* height: 28px; */
	border-radius: 4px;
	border: none;
	color: #6a6f77;
	display: block;
	outline: 0;
	padding: 1em 1em;
	text-decoration: none;
	width: 100%;
	background-color: #FAFAFA;
}
.businessDetails-pic {
	float: left;
}

.businessDetails-pic-box {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 28px 58px;
	border: 1px dashed #8C8888;
	border-radius: 8px;
}

.businessDetails-picture img {
	width: 50px;
	height: 50px;
	border-radius: 50%;
}

.businessDetails-picture-txt {
	color: #BFBFBF;
	font-size: 10px;
	margin-top: 5px;
}
/* //选择标签 */
.label-selected {
	line-height: 28px;
	height: 28px;
	background-color: #FAFAFA;
	position: relative;
	margin-bottom: 10px;
}

.label-selected li {
	display: inline-block;
	height: 15px;
	line-height: 15px;
	font-size: 13px;
	padding: 3px 10px;
	border: 1px solid #0091FF;
	border-radius: 4px;
	margin-right: 10px;
	cursor: pointer;
	margin-top: 5px;
	color: #0091FF;
}

.labelItem {
	margin-bottom: 10px;
	display: none;
}

.label-item {
	border: 1px solid #e6e6e6;
	padding: 10px;
	border-radius: 0 2px 2px 0;
	position: relative;
	overflow: hidden;
	background-color: #ffffff;
}

.label-item li {
	display: inline-block;
	height: 27px;
	line-height: 27px;
	font-size: .8rem;
	padding: 0 1rem;
	border: 1px solid #e6e6e6;
	border-radius: 2px;
	cursor: pointer;
	margin-bottom: 5px;
	margin-left: 2px;
	color: #666666;
}

.label-item{
  color: #cccccc;
}
.selected {
	color: #cccccc;
}
/* 下拉箭头 */
.show-labelitem{
  float: right;
	line-height: 28px;
	height: 28px;
	display: flex;
	width: 28px;
	justify-content: center;
	align-items: center;
}
.show-labelitems{
	float: right;
	line-height: 28px;
	height: 28px;
	display: flex;
	width: 28px;
	justify-content: center;
	align-items: center;
}
.show-labelitem img{
  width: 11px;
}
.show-labelitems img{
	width: 11px;
}
.hide-labelitem{
  line-height: 28px;
	height: 28px;
	display: flex;
	width: 28px;
	justify-content: center;
	align-items: center;
}
.hide-labelitems{
	line-height: 28px;
	height: 28px;
	display: flex;
	width: 28px;
	justify-content: center;
	align-items: center;
}
.hide-labelitems{
  position: absolute;
  top: 0;
  right: 0;
}
.show-labelitems{
	position: absolute;
  top: 0;
  right: 0;
}
.hide-labelitems img{
	width: 18px;
}
.company-information-rt {
	float: left;
	margin-bottom: 39px;
	background-color: #ffffff;
	width: 383px;
	text-align: center;
}

.company-classification {
	width: 383px;
	background: #ffffff;
	height: 280px;
	position: relative;
}
.company-information-title {
	position: absolute;
	font-size: 18px;
	top: 14px;
	color: #3B3B3B;
	font-weight: 500;
}
.company-information-title-img {
	width: 75px;
	height: 75px
}
/* 城市选择 */
.cityItem{
	border: none;
	background-color: #FAFAFA;
	height: 28px;
	line-height: 28px;
	color: #757575;
	width: 32.5%;
}
select{
     outline: none;
}
/* button*/
.btns{
	margin-top:60px;
	text-align: right;
	width: 100%;
}
.checkBtnItem{
	width: 18%;
	height: 37px;
	line-height: 37px;
}
.cancel{
	border: 1px solid #B0A7A7;
	color: #B0A7A7;
	margin-right: 26px;
	background-color: #ffffff;
}
.submit{
	color: #ffffff;
	border: 1px solid;
	border-image: linear-gradient(to left,#2AADFF,#587CF7) 1;
	background-image: linear-gradient(to left,#2AADFF,#587CF7);
}
/* 发布岗位 */
.businessCheck{
  float: left;
  color: #587CF7;
  height: 28px;
  line-height: 28px;
  border: 1px solid #587CF7;
  width: 80px;
  font-size: 12px;
  text-align: center;
  margin-right: 26px;
  cursor: pointer;
}
.businessCheck-active{
	background-color: #587CF7;
	color: #ffffff;
}
.personalCore-right{
  width: 307px;
  float: left;
  height: 418px;
  background-color: #fff;
  border-radius: 10px;
}
.personalCores-right-info{
  overflow: hidden;
  width: 100%;
  height: 122px;
  border-bottom: 1px solid #ECECEC;
}
.personalCores-right-info img{
  float: left;
  width: 75px;
  height: 75px;
  margin-top: 27px;
  margin-left: 15px;
  margin-right: 15px;
}
.personalCores-right-info-divs{
  float: left;
  margin-top: 36px;
  width: 60%;
}
.personalCores-right-info-div-name{
  font-size: 18px;
  margin-bottom: 8px;
}
.personalCores-right-info-div-vip{
  font-size: 12px;
  color: #E7BD7F;
  width: 71px;
  height: 19px;
  line-height: 19px;
  background-color: #373333;
  text-align: center;
  border-top-left-radius: 10px;
  border-bottom-right-radius: 10px;
  cursor: pointer;
}

.project-dropdown{
  height:250px;
  overflow: auto;
}
.project-dropdown::-webkit-scrollbar{
  width: 5px;
  height: 5px;
  background-color: #F5F5F5;
}
.project-dropdown::-webkit-scrollbar-track{
  border-radius: 10px;
  background-color: #F5F5F5;
}
/* 行业 */
.hotss-unify{
  width: 1000px;
  margin: 0 auto;
  background-color: #fff;
  /*margin-top: -15px;*/
  /*margin-bottom: 20px;*/
  z-index: 999;
  position: fixed !important;
  left: 0;
  right: 0;
  height: 500px !important;
}
.hots-titles-unify{
  font-weight: 550;
  margin-left: 30px;
  padding-top: 14px;
  font-size: 18px;
}
.hots-contents-unify{
  overflow: hidden;
  margin-top: 18px;
}
.hots-left-unify{
  float: left;
  width: 218px;
  margin-right: 30px;
  height: 401px;
  overflow-y: auto;
}
.hots-left-label-unify div{
  color: #868686;
  height: 39px;
  line-height: 39px;
  font-size: 14px;
  padding-left: 40px;
  cursor: pointer;
}
.hots-left-unify .active{
  background-color: #F2F7FF;
  color: #027FFE;
}
.hots-right-unify{
  float: left;
  width: 72%;
  font-size: 14px;
  height: 401px;
  margin-bottom: 10px;
  overflow-y:auto;
}
.hots-right-box-unify{
  display: inline-block;
}
.hots-right-box-unify{
  margin-top: 18px;
}
.hots-right-box:first-child{
  margin-top: 0;
}
.hots-right-h1{
  text-align: left;
  font-weight: 550;
  font-size: 16px;
  margin-bottom: 18px;
}
.hots-right-cont-unify{
  font-size: 14px;
  overflow: hidden;
  float: left;
}
.hots-right-cont-unify div{
  color: #A1A1A1;
  float: left;
  margin-right: 20px;
  font-size: 14px;
  margin-bottom: 15px;
  cursor: pointer;
  width: 135px;
  text-wrap: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.hots-right-cont-unify div:hover{
  color: #007aff;
  /*text-wrap: wrap;*/
}
.hots-right-cont-unify div:nth-child(12n){
  margin-bottom: 30px;
}
.shade-unify{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .3);
  z-index: 998;
}
/* 职位标签 */
.releaseJob-tabel{
  z-index: 999;
  position: fixed;
  background-color: #fff;
  width: 40%;
  margin-left: 30%;
  top: 20%;
}
.releaseJob-tabel-title{
  font-weight: 550;
  margin-left: 30px;
  padding-top: 25px;
  font-size: 18px;
  overflow: hidden;
}
.releaseJob-tabel-title div{
  float: left;
}
.releaseJob-tabel-title img{
  float: right;
  width: 24px;
  height: 24px;
  margin-right: 16px;
}
.releaseJob-tabels{
  overflow: hidden;
  margin-top: 15px;
  margin-left: 30px;
}
.releaseJob-tabels-tabel{
  float: left;
  margin-right: 15px;
  margin-bottom: 15px;
  font-size: 14px;
  padding: 0 15px;
  border: 1px solid #E4E4E4;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  cursor: pointer;
  color: #757575;
}
.releaseJob-tabel-actives{
  border: 1px solid #587CF7;
  color: #587CF7;
}
.releaseJob-tabel-btns{
  margin-top: 20px;
  margin-bottom: 20px;
  overflow: hidden;
  margin-right: 30px;
}
.releaseJob-tabel-btns div:first-child{
  float: right;
  font-size: 14px;
  color: #fff;
  background-color: #587CF7;
  padding: 8px 25px;
  border-radius: 5px;
  margin-left: 15px;
  cursor: pointer;
}
.releaseJob-tabel-btns div:last-child{
  float: right;
  font-size: 14px;
  color: #587CF7;
  padding: 7px 24px;
  border-radius: 5px;
  margin-left: 15px;
  border: 1px solid #587CF7;
  cursor: pointer;
}
/*2023-4-26*/
.resume-box-releaseJobVue {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.resume-left-releaseJobVue{
  float: left;
  width: 857px;
  margin-right: 24px;
}
.resume-modular-filling-releaseJobVue {
  width: 857px;
  margin-bottom: 25px;
}
.resume-modular-fillBox-releaseJobVue {
  padding: 0 30px 20px 30px;
  background-color: #fff;
  margin-bottom: 26px;
}
.resume-modular-title-name-releaseJobVue{
  /*margin-top: 23px;*/
  /* margin-left: 41px; */
  height: 25px;
  line-height: 25px;
  margin-bottom: 21px;
  font-size: 18px;
  font-weight: 550;
}
.resume-modular-fill-releaseJobVue {
  display: flex;
}
.resume-fillDetails-releaseJobVue {
  display: flex;
  flex-direction: column;
  flex: 1;
  -webkit-box-flex: 1;
  overflow: hidden;
  margin-bottom: 26px;
  margin-right: 30px;
}
.fillBusinessDetails-name-releaseJobVue {
  float: left;
  overflow: hidden;
  height: 22px;
  line-height: 22px;
  margin-bottom: 14px;
  /*width: 72px;*/
  /*width: 23%;*/
  color: #6D6D6D;
  margin-right: 30px;
}
.fillResumeDetails-name-releaseJobVue {
  float: left;
  height: 22px;
  line-height: 22px;
  font-size: 16px;
}
.resume-fillDetails-content-releaseJobVue {
  float: left;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.resume-fillDetails-content-picker-releaseJobVue {
  width: 100% !important;
}

.resume-fillDetails-content-picker-releaseJobVue input {
  /*border: none;*/
  height: 36px;
  line-height: 36px;
  border: 1px solid #DFDFDF;
}
.resume-fill-detils-releaseJobVue {
  box-sizing: border-box;
  font-size: 14px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #DFDFDF;
  color: #6a6f77;
  display: block;
  outline: 0;
  padding: 0 1em;
  text-decoration: none;
  width: 100%;
}
.pull-down-icon-box-releaseJobVue{
  height: 36px;line-height: 36px;position: absolute;right: 10px;top: 0
}
.resume-fill-introduce-releaseJobVue {
  font-size: 14px;
  width: 100%;
}
.resume-fill-textarea-releaseJobVue {
  outline: 0;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 20px;
  border-radius: 4px;
  border: none;
  border: 1px solid #DFDFDF;
  color: #6a6f77;
  display: block;
  outline: 0;
  padding: 1em 1em;
  text-decoration: none;
  /*width: 746px;*/
  width: 100%;
  resize:none;
  /*background: #F8F9FA;*/
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
.resume-modular-tabel-releaseJobVue {
  /*margin-left: 41px;*/
  overflow: hidden;
  /*height: 49px;*/
  padding-top: 9px;
  padding-bottom: 10px;
  /*background: #F8F9FA;*/
  border: 1px solid #DFDFDF;
  position: relative;
}

.resume-modular-tabel-releaseJobVue div {
  float: left;
  font-size: 14px;
  line-height: 30px;
  padding-right: 26px;
  /*border-right: 2px solid #979797;*/
  margin-right: 25px;
  padding-left: 1em;
  color: #6a6f77;
}
.resume-modular-add-releaseJobVue {
  width: 14px;
  position: absolute;
  right: 1em;
  margin-top: 8px;
}
/* 按钮 */
.resumeBtns-releaseJobVue {
  text-align: center;
  width: 100%;
  font-size: 16px;
  margin-top: 54px;
}

.resumeCheckBtnItem-releaseJobVue {
  width: 147px;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  font-size: 16px;
  border: 1px solid #B0A7A7;
}

.resumeCancel-releaseJobVue {
  /*border: 1px solid #B0A7A7;*/
  color: #6D6D6D;
  background: #f6f6f6;
  margin-left: 40px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #979797;
}

.resumeSub-releaseJobVue {
  color: #fff;
  /*border: 1px solid #587CF7;*/
  background: #587CF7;

}

.asterisk {
  color: #FF0000;
  float: left;
  margin-top: -1px;
  font-size: 17px;
}
.personalCore-right-releaseJobVue{
  width: 307px;
  float: left;
  height: 421px;
  background-color: #fff;
  border-radius: 10px;
}
.personalCore-right-info-releaseJobVue{
  overflow: hidden;
  width: 100%;
  height: 122px;
  border-bottom: 1px solid #ECECEC;
}
.personalCore-right-info-releaseJobVue img{
  float: left;
  width: 75px;
  height: 75px;
  margin-top: 27px;
  margin-left: 15px;
  margin-right: 30px;
  border-radius: 50%;
}
.releaseJobVue-right-info-div-box{
  float: left;
  margin-top: 34px;
  font-size: 18px;
}
.personalCore-right-box{
  width: 100%;
}
.personalCore-right-boxs{
  width: 110px;
  height: 110px;
  display: inline-block;
  position: relative;
  margin-left: 44px;
  margin-top: 24px;
  cursor: pointer;
}
.personalCore-right-boxs img{
  width: 100%;
  height: 100%;
}
.personalCore-right-boxs div{
  position: absolute;
  top: 70px;
  left: 19px;
  font-size: 18px;
}
.releaseJobVue-right-boxs{
  width: 110px;
  height: 110px;
  display: inline-block;
  position: relative;
}
.releaseJobVue-right-boxs img{
  width: 100%;
  height: 100%;
}
.releaseJobVue-right-boxs div{
  position: absolute;
  top: 70px;
  left: 19px;
  font-size: 18px;
}
.linkmanRadio{
  height: 24px;
  margin-top: 6px;
  margin-left: 10px;
}
.linkmanRadio .el-radio__inner{
  width: 24px;
  height: 24px;
}
.linkmanRadio.is-checked .el-radio__inner {
  border-color: #1FB72A !important;
  background: #1FB72A !important;
}
.linkmanRadios .is-checked .el-radio__inner {
  border-color: #DFDFDF !important;
  background: #fff !important;
}
.linkmanRadios .el-radio__input.is-checked+.el-radio__label {
  color: #DFDFDF !important;
}
.linkmanRadio .el-radio__inner:after {
  content: '✔';
  width: auto;
  height: auto;
  border-radius: 50%;
  background-color: unset;
  /*content: "";*/
  color: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%,-50%) scale(0);
  transform: translate(-50%,-50%) scale(0);
  -webkit-transition: -webkit-transform .15s ease-in;
  transition: -webkit-transform .15s ease-in;
  transition: transform .15s ease-in;
  transition: transform .15s ease-in,-webkit-transform .15s ease-in;
}
.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner{
  -webkit-box-shadow: 0 0 2px 2px #fff;
  box-shadow: 0 0 2px 2px #fff;
}
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield; /* Firefox */
}
</style>



// WEBPACK FOOTER //
// src/views/enterprise/releaseJob.vue